import { render, staticRenderFns } from "./MyLoadsVersion2.vue?vue&type=template&id=8abb257e&scoped=true"
import script from "./MyLoadsVersion2.vue?vue&type=script&lang=js"
export * from "./MyLoadsVersion2.vue?vue&type=script&lang=js"
import style0 from "./MyLoadsVersion2.vue?vue&type=style&index=0&id=8abb257e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abb257e",
  null
  
)

export default component.exports